// ABOUTME: Modal asking whether to split all backordered lines off an order into a new order.
// ABOUTME: Yes splits the backorder lines off, No opens the manual split modal.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";

const MSplitBackorder = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:3,
                    display:"flex",
                    flexDirection:"column",
                    gap:1,
                    maxWidth:500,
                }}
            >
                <Subheading>{t("mc_split_backorder_title")}</Subheading>
                <Text center light>{t("mc_split_backorder_subtitle")}</Text>
            </Box>
            <Box
                component="footer"
                sx={{
                    display:"flex",
                    width:1,
                    paddingBottom:"16px",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    paddingLeft:3,
                    paddingTop:2,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    gap:2,
                }}
            >
                <Shbutton
                    className={"group-btn"}
                    color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                    variant="contained"
                    onClick={props.onNo}
                >
                    {t("no")}
                </Shbutton>
                    <Shbutton
                        className={"group-btn"}
                        color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        variant="contained"
                        isLoading={props.isLoading}
                        onClick={props.onYes}
                    >
                        {t("yes")}
                    </Shbutton>
            </Box>
        </SHModal>
    )
}

export default MSplitBackorder;
